<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-1">
    <i class="far fa-star"></i>
    <ng-container i18n>Assign Booking Rating For Automated Reviews</ng-container>
    <app-page-help
      infoTooltip="Overall rating for this booking will be calculated by the average rating of all mentioned categories. The overall rating will be used to find the template for automated reviews. The rating will also be used to automatically populate data for manual reviews"
      i18n-infoTooltip
    ></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0">
  <div class="d-flex flex-column gap-3">
    <div class="card" *ngFor="let item of categoryRatings.controls; let i = index" [formGroup]="item">
      <div class="card-header d-flex">
        <div class="text-semi-bold">{{ item.get('type').value | startCase }}</div>
        <div class="ml-auto">
          <app-rating [rating]="item.get('stars').value" [editable]="true" (rate)="onRate(item, $event)"></app-rating>
        </div>
      </div>
      <div class="card-body">
        <mat-form-field2 class="mat-block">
          <input matInput placeholder="Comment" formControlName="comment" />
        </mat-form-field2>
        <mat-form-field2 class="mat-block">
          <app-select
            [items]="tags[item.get('type').value]"
            bindLabel="label"
            bindValue="id"
            [multiple]="true"
            placeholder="Category Tags"
            formControlName="tags"
          ></app-select>
        </mat-form-field2>
        <mat-error *ngIf="item.get('stars').touched && item.get('stars').hasError('required')" class="mt-3" i18n>
          Please rate this category
        </mat-error>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSave(categoryRatings)"
    type="button"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
  >
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
